// This is temporary until all users are migrated to the new permission entry.
const getIsContributor = ({permission} = {}) => (typeof permission === 'object' ? permission.permission : permission) === 'admin';

export default getIsContributor;
